import React, { useContext, useState } from 'react'
import { Button, ListGroup, Modal, Nav, Spinner } from 'react-bootstrap';
import { DataContext } from '../../js/App';
import { getUUID, SEND_POST_REQUEST as sendPostRequest } from '../../utils/helpers';
import { REPORT_SUBMIT_FINAL, REPORT_SUBMIT } from '../../config';
import { loadReCaptcha } from 'react-recaptcha-google';
import { ReCaptcha } from 'react-recaptcha-google'

import './overview.scss'

const Overview = () => {
    const context = useContext(DataContext);
    const { policyForm, formValues, setActiveTab, appUserPolicyData, requiredFields } = context;
    const [loading, setLoading] = useState(false);
    const [serverMessage, setServerMessage] = useState("");
    const [formUUID, setFormUUID] = useState(getUUID());
    const [submitButton, setSubmitButton] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showMissingFieldModal, setShowMissingFieldModal] = useState(false);
    const [missingRequiredField, setMissingRequiredField] = useState(false);
    const [validated, setValidated] = useState(false);
    const [recaptchaElement, setRecaptchaElement] = useState(null);
    const [recaptchaLoadedCorrectly, setRecaptchaLoadedCorrectly] = useState(false);
    const [requiredFieldsLabels, setRequiredFieldsLabels] = useState("");
    const pageNames = policyForm && Object.values(policyForm).map((page) => page.title);


    loadReCaptcha();

    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    const handleMissingFieldClose = () => setShowMissingFieldModal(false);
    const handleMissingFieldShow = () => setShowMissingFieldModal(true);

    const recapthaChanged = (response) => {
        if (response) {
            setValidated(true);
        } else {
            setValidated(false);
        }
    }

    const recaptchaLoaded = () => {
        if (!recaptchaLoadedCorrectly && recaptchaElement) {
            recaptchaElement.reset();
            recaptchaElement.execute();
            setRecaptchaLoadedCorrectly(true);
        }
    }

    const submitForm = () => {
        setMissingRequiredField(false);
        let submitObject = {}
        let intRequiredField = false;
        submitObject.apiKey = appUserPolicyData.apiKey;
        submitObject.appUserPolicyId = appUserPolicyData.id;
        submitObject.uuid = formUUID;
        submitObject.data = formValues;
        submitObject.formData = policyForm;
        let tmpRequiredFieldsLabels = [];

        requiredFields.reverse().forEach(key => {
            if (typeof formValues[key] === 'undefined') {
                policyForm.forEach(page => {
                    page.fields.forEach(field => {
                        if(field.name === key){
                            tmpRequiredFieldsLabels.push(<ListGroup.Item>{field.label}</ListGroup.Item>);
                        }
                    });
                });
                setMissingRequiredField(true);
                setRequiredFieldsLabels(tmpRequiredFieldsLabels);
                intRequiredField = true;
                handleMissingFieldShow();
            }
        });

        if (!intRequiredField) {            
            if (validated) {
                setLoading(true);
                handleShow();
                sendPostRequest(submitObject, REPORT_SUBMIT)
                    .then(() => {
                        sendPostRequest(
                            submitObject,
                            REPORT_SUBMIT_FINAL
                        ).then(response => {
                            response.json().then(jsonResponse => {
                                setLoading(false);
                                if (jsonResponse.status === 'error') {
                                    setServerMessage("There was a problem by sending the report, please try again later.");
                                } else {
                                    setServerMessage("Your report has been successfully submitted")
                                    setSubmitButton(false);
                                }
                            });
                        });
                    });
            }
        }
    }
    return (<>
        {!missingRequiredField && (
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header>
                    <Modal.Title>Report {loading ? "sending..." : "sent"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading === true ? (<Spinner animation="border" variant="primary" />) : (<div>{serverMessage}</div>)}
                </Modal.Body>
                {(!loading) && (
                    <Modal.Footer>
                        <Button variant="outline-primary" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                )}
            </Modal>)}
        {missingRequiredField && (
            <Modal show={showMissingFieldModal} onHide={handleMissingFieldClose} centered>
                <Modal.Header>
                    <Modal.Title>Required fields missing</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    There are some required fields missing. Please return to the form and complete in full.
                    <h5 className="mt-3">Required fields to fill</h5>
                    <ListGroup variant="flush">
                        {requiredFieldsLabels}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleMissingFieldClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        )}
        {policyForm !== null &&
            pageNames &&
            pageNames.map((pageName, index) => (
                <div key={pageName + index} className='tabSwitcher'>
                    <div className='overview-section'>
                        <div className='blockTitle'>{pageName}</div>
                        <a data-pagename={pageName}
                            className="overviewLink"
                            onClick={e => setActiveTab(e.target.dataset.pagename)}>Show</a>
                    </div>
                </div>
            ))}        
        
        {!recaptchaLoadedCorrectly && (
            <div dangerouslySetInnerHTML={{ __html: '<script src="https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit"></script>' }}>
            </div>           
        )}
        <ReCaptcha
            ref={(el) => setRecaptchaElement(el)}
            render="explicit"
            size="invisible"
            sitekey="6LeytyYeAAAAAFidsPzDwHF3eqx6_AmkN6m8pwtZ"
            onloadCallback={recaptchaLoaded}
            verifyCallback={recapthaChanged}
        />

        <div className='submitButtonContainer'>
            <Button disabled={!submitButton} variant="primary" onClick={() => submitForm()}>{submitButton ? "Submit" : "Report submitted"}</Button>
        </div>

    </>
    )
}

export default Overview;